import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { AppConstants } from '../../app.constants';
import { PlaylistItemLinkModel } from '../../core/models/view-models/playlist-item-models/playlist-item-link.model';
import { PlaylistItemDTO } from '../../core/models/view-models/playlist-item-models/playlist-item-dto.model';

@Component({
  selector: 'zoom-input',
  templateUrl: './zoom-input.component.html',
  styleUrls: ['./zoom-input.component.scss'],
  standalone: true,
  imports: [FormsModule, MatTooltipModule]
})
export class ZoomInputComponent {
  @Input() source: PlaylistItemLinkModel;
  @Input() item: PlaylistItemDTO;

  public onZoomInputChanged(event: Event, source: PlaylistItemLinkModel): void {
    const value: number = +(event.target as HTMLInputElement).value;
    (event.target as HTMLInputElement).value =
      (value < AppConstants.PLAYLIST_MIN_DISPLAY_ZOOM_LEVEL ?
        AppConstants.PLAYLIST_MIN_DISPLAY_ZOOM_LEVEL :
          value > AppConstants.PLAYLIST_MAX_ZOOM_LEVEL ?
          AppConstants.PLAYLIST_MAX_ZOOM_LEVEL :
            value).toString();

    source.ZoomLevel = +(event.target as HTMLInputElement).value;
    this.item.IsContentStretched = false;
  }

  public zoomIn() {
    this.item.IsContentStretched = false;

    this.source.ZoomLevel =
      this.source.ZoomLevel < (AppConstants.PLAYLIST_MAX_ZOOM_LEVEL - AppConstants.PLAYLIST_ZOOM_LEVEL_STEP) ?
        this.source.ZoomLevel + AppConstants.PLAYLIST_ZOOM_LEVEL_STEP :
          AppConstants.PLAYLIST_MAX_ZOOM_LEVEL;
  }

  public zoomOut() {
    this.item.IsContentStretched = false;

    this.source.ZoomLevel = this.source.ZoomLevel >= (AppConstants.PLAYLIST_MIN_ZOOM_LEVEL + AppConstants.PLAYLIST_ZOOM_LEVEL_STEP) ?
      this.source.ZoomLevel - AppConstants.PLAYLIST_ZOOM_LEVEL_STEP :
      AppConstants.PLAYLIST_MIN_ZOOM_LEVEL;
  }
}
